/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
import { apiPost } from 'utils'
import { IAuditRequest, IEditionManageItem, IEditionManageRequest, ISaveVersionRequest } from 'model'
import { DropdownBox, PaginationResponse, XhhyBaseRequest, XhhyRequest, XhhyResponse } from 'Xhhy-common/common'

  /**
   * 版本列表
   * @param params
   */
  export const apiAppversionList = async (params: IEditionManageRequest) => {
   return await apiPost<IEditionManageRequest, PaginationResponse<IEditionManageItem>>(`/apppocapi/appversion/list`, params)
  }

  /**
   * 审核版本
   * @param params
   */
  export const apiAudit = async (params: IAuditRequest) => {
  return await apiPost<IAuditRequest, XhhyResponse>(`/apppocapi/appversion/audit`, params)
  }

  /**
   * 发布版本
   * @param params
   */
  export const apiRelease = async (params: XhhyBaseRequest) => {
    return await apiPost<XhhyBaseRequest, XhhyResponse>(`/apppocapi/appversion/release`, params)
  }

  /**
   * 发布新版本
   * @param params
   */
  export const apiNewRelease = async (params: ISaveVersionRequest) => {
    return await apiPost<ISaveVersionRequest, XhhyResponse>(`/apppocapi/appversion/save`, params)
  }

  /**
   * APP名称下拉框
   * @param params
   */
  export const apiAppNameBox = async (params: XhhyRequest) => {
    return await apiPost<XhhyRequest, Array<DropdownBox>>(`/apppocapi/appversion/selectAppNameComboBox`, params)
  }

  /**
   * APP平台下拉框
   * @param params
   */
  export const apiAppTypeBox = async (params: XhhyRequest) => {
    return await apiPost<XhhyRequest, Array<DropdownBox>>(`/apppocapi/appversion/selectAppTypeComboBox`, params)
  }

  /**
   * APP更新要求下拉框
   * @param params
   */
  export const apiAppUpdateBox = async (params: XhhyRequest) => {
    return await apiPost<XhhyRequest, Array<DropdownBox>>(`/apppocapi/appversion/selectUpdateRequireComboBox`, params)
  }
  